var map = {
	"./arrow-left.svg": "./frontend/icons/arrow-left.svg",
	"./arrow-right.svg": "./frontend/icons/arrow-right.svg",
	"./carrot-down.svg": "./frontend/icons/carrot-down.svg",
	"./carrot-up.svg": "./frontend/icons/carrot-up.svg",
	"./chevron-down.svg": "./frontend/icons/chevron-down.svg",
	"./chevron-left.svg": "./frontend/icons/chevron-left.svg",
	"./chevron-right.svg": "./frontend/icons/chevron-right.svg",
	"./chevron-up.svg": "./frontend/icons/chevron-up.svg",
	"./cog.svg": "./frontend/icons/cog.svg",
	"./cross.svg": "./frontend/icons/cross.svg",
	"./decrease.svg": "./frontend/icons/decrease.svg",
	"./email.svg": "./frontend/icons/email.svg",
	"./facebook.svg": "./frontend/icons/facebook.svg",
	"./increase.svg": "./frontend/icons/increase.svg",
	"./instagram.svg": "./frontend/icons/instagram.svg",
	"./magnifying-glass.svg": "./frontend/icons/magnifying-glass.svg",
	"./map-administration.svg": "./frontend/icons/map-administration.svg",
	"./map-church.svg": "./frontend/icons/map-church.svg",
	"./map-giftshop.svg": "./frontend/icons/map-giftshop.svg",
	"./map-information.svg": "./frontend/icons/map-information.svg",
	"./map-parking.svg": "./frontend/icons/map-parking.svg",
	"./map-restaurant.svg": "./frontend/icons/map-restaurant.svg",
	"./map-washroom.svg": "./frontend/icons/map-washroom.svg",
	"./menu.svg": "./frontend/icons/menu.svg",
	"./search.svg": "./frontend/icons/search.svg",
	"./twitter.svg": "./frontend/icons/twitter.svg",
	"./weather-cloudy.svg": "./frontend/icons/weather-cloudy.svg",
	"./weather-fair-moon.svg": "./frontend/icons/weather-fair-moon.svg",
	"./weather-fair.svg": "./frontend/icons/weather-fair.svg",
	"./weather-haze.svg": "./frontend/icons/weather-haze.svg",
	"./weather-light-snow.svg": "./frontend/icons/weather-light-snow.svg",
	"./weather-mostly-cloudy-moon.svg": "./frontend/icons/weather-mostly-cloudy-moon.svg",
	"./weather-mostly-cloudy.svg": "./frontend/icons/weather-mostly-cloudy.svg",
	"./weather-partly-cloudy-moon.svg": "./frontend/icons/weather-partly-cloudy-moon.svg",
	"./weather-partly-cloudy.svg": "./frontend/icons/weather-partly-cloudy.svg",
	"./weather-showers.svg": "./frontend/icons/weather-showers.svg",
	"./weather-sunny.svg": "./frontend/icons/weather-sunny.svg",
	"./youtube.svg": "./frontend/icons/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./frontend/icons sync recursive ^\\.\\/.*$";